 import * as Yup from "yup";

export const employeeProfileValidationSchema = Yup.object({
  dateOfBirth: Yup.string().nullable(),
  familyHoliday: Yup.string()
    .nullable()
    .matches(/^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/, "Invalid format. Use MM-DD (e.g., 12-19)"),
  street: Yup.string()
    .max(200, "Street address cannot exceed 200 characters"),
  city: Yup.string()
    .max(100, "City cannot exceed 100 characters"),
  state: Yup.string()
    .max(100, "State cannot exceed 100 characters"),
  zipCode: Yup.string()
    .max(20, "Zip code cannot exceed 20 characters"),
  country: Yup.string()
    .max(100, "Country cannot exceed 100 characters"),
  emergencyContactName: Yup.string()
    .max(100, "Emergency contact name cannot exceed 100 characters"),
  emergencyContactPhone: Yup.string()
    .max(20, "Emergency contact phone cannot exceed 20 characters"),
  phoneNumber: Yup.string()
    .max(50, "Phone number cannot exceed 50 characters"),
});

export interface EmployeeProfileFormValues {
  dateOfBirth: string;
  familyHoliday: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phoneNumber: string;
  emergencyContactName: string;
  emergencyContactPhone: string;
}

export const getInitialEmployeeProfileValues = (user: any): EmployeeProfileFormValues => ({
  dateOfBirth: user?.dateOfBirth || "",
  familyHoliday: user?.familyHoliday || "",
  street: user?.street || "",
  city: user?.city || "",
  state: user?.state || "",
  zipCode: user?.zipCode || "",
  country: user?.country || "",
  phoneNumber: user?.phoneNumber || "",
  emergencyContactName: user?.emergencyContactName || "",
  emergencyContactPhone: user?.emergencyContactPhone || "",
});
